// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__33ecf","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3VtXA"};